import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeDollarSign',
    standalone: false
})
export class RemoveDollarSignPipe implements PipeTransform {
  transform(value: string): string {
    // Check if the input value is a string
    if (typeof value !== 'string') {
      return value; // Return the input value unchanged
    }

   // Remove dollar sign ($)
   let result = value.replace(/\$/g, '');

   // Replace caret (^) with specified character (e.g., 'pow')
   result = result.replace(/\^/g, 'pow');

   // Remove backslash (\)
   result = result.replace(/\\\\\n\\\\n|\\/g, '');

  //  result = result.replace(/\\/g, '');




   return result;
  }
}
